// @ts-check
import './status-checkbox.scss';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {string} props.id
 * @param {boolean} props.isSelected
 * @param {string} props.label
 * @param {import('../../../../types').StatusValue} props.value
 * @param {(value: import('../../../../types').StatusValue) => void} props.handleChange
 */
export default function StatusCheckbox({ id, isSelected, label, value, handleChange }) {
	function onChange() {
		handleChange(value);
	}

	return (
		<div className={`status-checkbox-container status-${value}${isSelected ? ' is-selected' : ''}`} aria-checked={isSelected}>
			<input type="checkbox" id={id} onChange={onChange} checked={isSelected} />
			<label className="status-label" htmlFor={id}>{label}</label>
		</div>
	);
}
